const FLEETHAND_PROD_URL = 'https://app.fleethand.com';
const FLEETHAND_PREPROD_URL = 'https://preprod.fleethand.com';

export const prepareLinkToFleethandTaskList = (transportId: number) => {
  const baseUrl = window.$isDevMode ? FLEETHAND_PREPROD_URL : FLEETHAND_PROD_URL;
  return `${baseUrl}/tasks/${transportId}/manager/pro`;
};
